import { render, staticRenderFns } from "./PhoneTerminal.vue?vue&type=template&id=224362ac&scoped=true"
import script from "./PhoneTerminal.vue?vue&type=script&lang=js"
export * from "./PhoneTerminal.vue?vue&type=script&lang=js"
import style0 from "./PhoneTerminal.vue?vue&type=style&index=0&id=224362ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224362ac",
  null
  
)

export default component.exports